module.exports = __webpack_public_path__ + "static/media/vector.a99b33f9.svg";